import { ReduxHelper } from 'utils/ReduxHelper';

import { CsrfTokenModule } from './CsrfTokenModule';

function getToken(state) {
    return CsrfTokenModule.getModuleState(state).token;
}

export const CsrfTokenSelectrors = {
    getToken,
};

export const BoundCsrfTokenSelectrors = ReduxHelper.bindSelectors(
    CsrfTokenSelectrors,
);
